module.exports = __webpack_public_path__ + "img/3.91d306e2.jpg";